import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49b6188e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note__wrapper" }, " *Please note. we will require proof before engaging in any projects on iknowa. ", -1))
const _hoisted_2 = { class: "sole-trader-data-wrapper rmd:!tw-w-[50%] md:!tw-h-full" }
const _hoisted_3 = {
  key: 0,
  class: "form__wrapper md:!tw-h-full md:!tw-m-0"
}
const _hoisted_4 = { class: "modal_input_wrapper tw-flex tw-flex-col tw-gap-4" }
const _hoisted_5 = { class: "modal_input !tw-m-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "input-lbl" }, "Title", -1))
const _hoisted_7 = { class: "modal_input !tw-m-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "input-lbl" }, "Membership number (optional)", -1))
const _hoisted_9 = { class: "modal_input !tw-m-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "input-lbl" }, "URL (optional)", -1))
const _hoisted_11 = { class: "modal_input !tw-m-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "input-lbl" }, "Evidence", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  Uploading file...", -1))
const _hoisted_15 = {
  key: 0,
  class: "add-more-data"
}
const _hoisted_16 = { class: "body-text" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "insurances-list" }
const _hoisted_19 = { class: "insurances-list__innner !tw-m-0" }
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ServiceIconWrapper = _resolveComponent("ServiceIconWrapper")!
  const _component_ItemListCard = _resolveComponent("ItemListCard")!
  const _component_WizardModal = _resolveComponent("WizardModal")!

  return (_openBlock(), _createBlock(_component_WizardModal, {
    hideFooter: true,
    hideBackButton: true,
    singleData: $setup.modelDetails,
    onOnClose: $setup.onClickBackButton
  }, {
    content: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        ($setup.isShowQualificationForm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_form, {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                rules: $setup.validation,
                ref: "certificationFormRef",
                class: "md:!tw-h-full"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createVNode(_component_v_select, {
                        items: $setup.certificateList,
                        "item-title": "name",
                        "item-value": "id",
                        placeholder: "e.g Plumbing & Heating",
                        rules: $setup.validation.certificateId,
                        modelValue: $setup.qualificationData.certificateId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.qualificationData.certificateId) = $event)),
                        variant: "outlined",
                        class: "c-select mb-2",
                        "menu-props": { contentClass: 'tags_dropdown' }
                      }, null, 8, ["items", "rules", "modelValue"]),
                      ($setup.qualificationData.certificateId === $setup.getOthersId)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 0,
                            density: "compact",
                            rules: $setup.validation.typeText,
                            placeholder: "E.g. Public liability",
                            variant: "outlined",
                            modelValue: $setup.customType,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customType) = $event)),
                            class: "c-input rounded-full tw-flex-row-reverse mt-4 mb-2"
                          }, null, 8, ["rules", "modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_v_text_field, {
                        density: "compact",
                        placeholder: "eg. 12345678",
                        variant: "outlined",
                        modelValue: $setup.qualificationData.registrationNumber,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.qualificationData.registrationNumber) = $event)),
                        class: "c-input rounded-full !tw-m-0"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_v_text_field, {
                        density: "compact",
                        placeholder: "Add Credential URL",
                        variant: "outlined",
                        modelValue: $setup.qualificationData.url,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.qualificationData.url) = $event)),
                        class: "c-input rounded-full !tw-m-0"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_v_file_input, {
                        class: "c-file !tw-m-0",
                        label: 
                    $setup.qualificationData.attachments[0]?.originalName
                      ? $setup.qualificationData.attachments[0]?.originalName
                      : `Upload`
                  ,
                        "prepend-icon": "mdi-upload",
                        variant: "solo",
                        flat: "",
                        "onClick:clear": $setup.clearAttachments,
                        onChange: $setup.onFileChange,
                        "error-messages": $setup.attachmentError
                      }, null, 8, ["label", "onClick:clear", "onChange", "error-messages"])
                    ]),
                    ($setup.isFileUploading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_v_progress_linear, {
                            "model-value": $setup.uploadProgress,
                            height: 10,
                            width: 5,
                            striped: "",
                            rounded: "",
                            color: "#0C0F4A"
                          }, null, 8, ["model-value"]),
                          _createTextVNode(" " + _toDisplayString($setup.uploadProgress) + " %", 1),
                          _hoisted_14
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_v_btn, {
                    class: _normalizeClass(["button disable", $setup.isSaveButtonDisable ? 'disable' : 'button-orange']),
                    loading: $setup.isQualificationSubmitting,
                    onClick: $setup.onClickAddQualification,
                    disabled: $setup.isSaveButtonDisable
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.isEditCertificate ? "update qualification" : "add qualification"), 1)
                    ]),
                    _: 1
                  }, 8, ["class", "loading", "onClick", "disabled"])
                ]),
                _: 1
              }, 8, ["rules"]),
              ($setup.userCertificates.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, [
                      _createTextVNode(" Nothing more to add? "),
                      _createElementVNode("span", {
                        class: "yellow-text",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.onClickCancelButton && $setup.onClickCancelButton(...args)))
                      }, [
                        _createTextVNode("Cancel"),
                        _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userCertificates, (certificate) => {
                    return (_openBlock(), _createBlock(_component_ItemListCard, {
                      key: certificate.id,
                      onClickDelete: () => $setup.deleteCertificate(certificate.id),
                      isShowLogo: true,
                      onClickEdit: () => $setup.editCertificate(certificate)
                    }, {
                      listItemLogo: _withCtx(() => [
                        _createVNode(_component_ServiceIconWrapper, { iconName: "tools" })
                      ]),
                      listItemCardTitle: _withCtx(() => [
                        _createTextVNode(_toDisplayString(certificate.metadata.name
                    ? certificate.metadata.name
                    : certificate.certificate.name), 1)
                      ]),
                      listItemCardLabel: _withCtx(() => [
                        _createTextVNode(_toDisplayString(certificate?.metadata?.registrationNumber), 1)
                      ]),
                      listItemCardText: _withCtx(() => [
                        _createTextVNode(_toDisplayString(certificate?.metadata?.url) + " ", 1),
                        (certificate?.attachment.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(certificate?.attachment[0]?.originalName), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onClickDelete", "onClickEdit"]))
                  }), 128))
                ]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border w-100 !tw-m-0",
                  onClick: $setup.onClickAddAnotherQualification
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("add another qualification")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_v_btn, {
                class: "button button-orange w-100",
                onClick: $setup.onClickQualificationContinue
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Continue")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["singleData", "onOnClose"]))
}